import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAdGroupTemplate } from "../queries/adGroupTemplates";
import { ENTITY } from "../constants";

export const AdGroupTemplateBreadcrumb = ({ match }) => {
  // Entity
  const { ADGROUPTEMPLATE } = ENTITY;

    const {
      data: adGroupTemplate,
      isLoading,
      isError,
      error,
    } = useGetAdGroupTemplate(match.params.adGroupTemplateId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (adGroupTemplate) {
      return <span>{trimString(adGroupTemplate[ADGROUPTEMPLATE.nameField], 20)}</span>;
    }
  
    return null;
  };